<template>
	<AmeliproErrorTemplate
		is-disconnect-message
		error-type="disconnect"
		btn-href="/login"
	/>
</template>

<script lang="ts">
	import Vue from 'vue';
	import Component from 'vue-class-component';

	@Component({})
	export default class LogoutView extends Vue {
		created() {
			this.$store.dispatch('garde/clearGarde');
			this.$store.dispatch('authentication/logout');
		}
	}
</script>
